// extracted by mini-css-extract-plugin
export default {"place_appear":"trans_place_appear__3gkFC","place_appear_active":"trans_place_appear_active__o6KeW"};